<div class="special-employee-cost-component" fxLayout="column">
    <div
        class="special-employee-cost-component_input"
        fxLayout="row"
        fxLayoutAlign="start none"
    >
        <dsn-input
            style="max-width: 186px; width: 100%"
            [size]="'medium'"
            [type]="'text'"
            [format]="'currency'"
            [placeholder]="'Salário'"
            [disabled]="false"
            [value]="employeeSalary"
            [name]="'cost'"
            [id]="'username-field'"
            [isInvalid]="false"
            [noValidate]="true"
            [invalidMessage]="''"
            [icon]="''"
            (onValueChange)="onValueChange($event)"
        ></dsn-input
        ><span
            class="{{
                isMobile() ? 'text-14-semi-bold mobile' : 'text-16-semi-bold'
            }} special-employee-cost-component_input-value"
            ><span
                class="{{
                    isMobile()
                        ? 'text-14-semi-bold mobile'
                        : 'text-16-semi-bold'
                }}"
                >x</span
            >{{ result }}
            <i
                class="fa-solid fa-equals {{ isMobile() && 'mobile' }}"
                style="margin: 0px var(--spacing-8)"
            ></i
            ><span
                class="special-employee-cost-component_input-result {{
                    isMobile()
                        ? 'text-14-semi-bold mobile'
                        : 'text-16-semi-bold'
                }} "
                >R$ {{ resultSalary }}</span
            ></span
        >
        <!-- <span class="text-14-regular">R$</span> -->
    </div>
    <div class="special-employee-cost-component-chart" fxLayout="column">
        <app-chart-historic
            [options]="options"
            [visualization]="visualization"
            [series]="series"
            [points]="points"
            [company]="company"
            [categoryName]="'column'"
        ></app-chart-historic>
    </div>
</div>
